// Central placeholders used across every legal page. Fill these in once and
// they propagate to Terms, Privacy, Cookies, Disclaimer, Acceptable Use,
// Billing, and the Footer company-identification block.
//
// Anything still in square brackets is intentionally unfilled — that signals
// "lawyer/founder needs to decide this" and it renders on-page that way.
const legalConfig = {
  entityName: '[LEGAL ENTITY NAME]',
  companyRegistrationNumber: '[COMPANY REGISTRATION NUMBER]',
  vatNumber: '[VAT NUMBER]',
  registeredAddress: '[REGISTERED ADDRESS]',
  contactEmail: 'cosmoestatescyprus@gmail.com',
  privacyEmail: 'cosmoestatescyprus@gmail.com',
  effectiveDate: '[EFFECTIVE DATE]',
  lastUpdated: '[EFFECTIVE DATE]',

  // Pricing
  pricePro: {
    monthly: '[PRICE — monthly]',
    quarterly: '[PRICE — quarterly]',
    yearly: '[PRICE — yearly]',
  },
  priceBoost: '[PRICE — Boost]',

  // Liability cap referenced in Terms 13.2(c)
  liabilityCap: '[AMOUNT — e.g. 100]',

  // Site
  websiteUrl: 'https://cosmoestates.cy',
  brand: 'CosmoEstates',
};

export default legalConfig;
